import {
  ADD_WHITE_LIST,
  ADD_WHITE_LIST_SUCCESS,
  CHANGE_ACCOUNT_STATUS,
  CHANGE_ACCOUNT_STATUS_SUCCESS,
  CHANGE_ETC_MISSING_STATUS,
  CHANGE_ETC_MISSING_STATUS_SUCCESS,
  CHANGE_MISSING_STATUS,
  CHANGE_MISSING_STATUS_SUCCESS,
  CHANGE_ROLE,
  CHANGE_ROLE_SUCCESS,
  GET_ADMIN_FOUND,
  GET_ADMIN_FOUND_SUCCESS,
  GET_ADMIN_MISSING,
  GET_ADMIN_MISSING_SUCCESS,
  GET_ETC_MISSING,
  GET_ETC_MISSING_SUCCESS,
  GET_LOG,
  GET_LOG_SUCCESS,
  GET_SETTING,
  GET_SETTING_SUCCESS,
  GET_USER,
  GET_USER_SUCCESS,
  GET_WHITE_LIST,
  GET_WHITE_LIST_SUCCESS,
  HIDE_ADMIN_MESSAGE,
  ON_HIDE_ADMIN_LOADER,
  ON_SHOW_ADMIN_LOADER,
  REMOVE_WHITE_LIST,
  REMOVE_WHITE_LIST_SUCCESS,
  UPDATE_SETTING,
  UPDATE_SETTING_SUCCESS,
  DELETE_EVENT,
  DELETE_EVENT_SUCEESS,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  CHANGE_ADDRESS,
  CHANGE_ADDRESS_SUCCESS,
  ADMIN_REPORT,
  ADMIN_REPORT_SUCEESS,
  ADMIN_GET_MISSION_BY_ID_SUCCESS,
  ADMIN_GET_MISSION_BY_ID,
  ON_UPDATE_Missing,
  ON_UPDATE_Missing_Success,
} from "../../constants/ActionTypes";

export const addWhiteList = (model) => {
  return {
    type: ADD_WHITE_LIST,
    payload: {
      UserManagementId: model.UserManagementId,
      DiscountPercent: model.DiscountPercent,
    },
  };
};

export const addWhiteListSuccess = () => {
  return {
    type: ADD_WHITE_LIST_SUCCESS,
  };
};

export const removeWhiteList = (whiteListId) => {
  return {
    type: REMOVE_WHITE_LIST,
    payload: {
      WhiteListId: whiteListId,
    },
  };
};

export const removeWhiteListSuccess = () => {
  return {
    type: REMOVE_WHITE_LIST_SUCCESS,
  };
};

export const getWhiteList = (
  pageIndex,
  searchText,
  fromDate,
  toDate,
  forceReresh
) => {
  return {
    type: GET_WHITE_LIST,
    payload: {
      pageIndex: pageIndex,
      searchText: searchText,
      fromDate: fromDate,
      toDate: toDate,
      forceReresh: forceReresh,
    },
  };
};

export const getWhiteListSuccess = (data) => {
  return {
    type: GET_WHITE_LIST_SUCCESS,
    payload: data,
  };
};

export const changeAccountStatus = (userManagementIds, setActive) => {
  return {
    type: CHANGE_ACCOUNT_STATUS,
    payload: {
      UserManagementIds: userManagementIds,
      SetActive: setActive,
    },
  };
};

export const changeAccountStatusSuccess = () => {
  return {
    type: CHANGE_ACCOUNT_STATUS_SUCCESS,
  };
};

export const changeRole = (userManagementIds, roleTypeKind) => {
  return {
    type: CHANGE_ROLE,
    payload: {
      UserManagementIds: userManagementIds,
      RoleTypeKind: roleTypeKind,
    },
  };
};

export const changeRoleSuccess = () => {
  return {
    type: CHANGE_ROLE_SUCCESS,
  };
};

export const changeMissingStatus = (missingIds, type) => {
  return {
    type: CHANGE_MISSING_STATUS,
    payload: {
      MissingIds: missingIds,
      MissingAdvertisingTypeKind: type,
    },
  };
};

export const changeMissingStatusSuccess = () => {
  return {
    type: CHANGE_MISSING_STATUS_SUCCESS,
  };
};

export const changeEtcMissingStatus = (etcMissingIds, type) => {
  return {
    type: CHANGE_ETC_MISSING_STATUS,
    payload: {
      EtcAdvertisingIds: etcMissingIds,
      MissingAdvertisingTypeKind: type,
    },
  };
};

export const changeEtcMissingStatusSuccess = () => {
  return {
    type: CHANGE_ETC_MISSING_STATUS_SUCCESS,
  };
};
export const getLog = (pageIndex, from, end) => {
  return {
    type: GET_LOG,
    payload: {
      pageIndex: pageIndex,
      from: from,
      end: end,
    },
  };
};

export const getLogSuccess = (data) => {
  return {
    type: GET_LOG_SUCCESS,
    payload: data,
  };
};

export const getUser = (
  userLevel,
  isActive,
  pageIndex,
  searchText,
  fromDate,
  toDate,
  forceReresh
) => {
  return {
    type: GET_USER,
    payload: {
      role: userLevel,
      status: isActive,
      pageIndex: pageIndex,
      searchText: searchText,
      fromDate: fromDate,
      toDate: toDate,
      forceReresh: forceReresh,
    },
  };
};

export const getUserSuccess = (data, forceRefresh) => {
  return {
    type: GET_USER_SUCCESS,
    payload: {
      data: data,
      foreceRefresh: forceRefresh,
    },
  };
};

export const getMissing = (isFound,justFindRequest,loadAll, searchText, missingSearchRequestStatus, missingPaymentStatus, fromDate, toDate, missingAdvertisingType, forceReresh) => {

  return {
    type: GET_ADMIN_MISSING,
    payload: {
      loadAll: loadAll,
      searchText: searchText,
      fromDate: fromDate,
      toDate: toDate,
      searchRequestStatusTypeKind: missingSearchRequestStatus,
      missingPaymentStatusType: missingPaymentStatus,
      missingAdvertisingType: missingAdvertisingType,
      forceReresh: forceReresh,
      isFound: isFound,
      justFindRequest: justFindRequest,

    }
  };
};

export const getMissingSuccess = (data) => {
  return {
    type: GET_ADMIN_MISSING_SUCCESS,
    payload: data,
  };
};

export const getEtcMissing = (
  pageIndex,
  searchText,
  missingPaymentStatus,
  fromDate,
  toDate,
  forceReresh
) => {
  return {
    type: GET_ETC_MISSING,
    payload: {
      pageIndex: pageIndex,
      searchText: searchText,
      missingPaymentStatusType: missingPaymentStatus,
      fromDate: fromDate,
      toDate: toDate,
      forceReresh: forceReresh,
    },
  };
};
export const getEtcMissingSuccess = (data) => {
  return {
    type: GET_ETC_MISSING_SUCCESS,
    payload: data,
  };
};

export const getFound = (
  pageIndex,
  searchText,
  fromDate,
  toDate,
  forceReresh
) => {
  return {
    type: GET_ADMIN_FOUND,
    payload: {
      pageIndex: pageIndex,
      searchText: searchText,
      fromDate: fromDate,
      toDate: toDate,
      forceReresh: forceReresh,
    },
  };
};
export const getFoundSuccess = (data) => {
  return {
    type: GET_ADMIN_FOUND_SUCCESS,
    payload: data,
  };
};

export const getSetting = () => {
  return {
    type: GET_SETTING,
  };
};
export const getSettingSuccess = (data) => {
  return {
    type: GET_SETTING_SUCCESS,
    payload: data,
  };
};

export const hideAdminMessage = () => {
  return {
    type: HIDE_ADMIN_MESSAGE,
  };
};

export const hideAdminLoader = () => {
  return {
    type: ON_HIDE_ADMIN_LOADER,
  };
};

export const showAdminMessage = (message) => {
  return {
    type: ON_SHOW_ADMIN_LOADER,
    payload: message,
  };
};

export const updateSetting = (setting) => {
  return {
    type: UPDATE_SETTING,
    payload: setting,
  };
};

export const updateSettingSuccess = () => {
  return {
    type: UPDATE_SETTING_SUCCESS,
  };
};

export const deleteEvent = (id) => {
  return {
    type: DELETE_EVENT,
    payload: {
      EventIds: [id],
    },
  };
};

export const deleteEventSucess = () => {
  return {
    type: DELETE_EVENT_SUCEESS,
  };
};

export const resetPassword = (userManagementId) => {
  return {
    type: RESET_PASSWORD,
    payload: {
      userManagementId: userManagementId,
    },
  };
};

export const resetPasswordSuccess = () => {
  return {
    type: RESET_PASSWORD_SUCCESS,
  };
};

export const changeAddress = (userManagementId, newAddress) => {
  return {
    type: CHANGE_ADDRESS,
    payload: {
      userManagementId: userManagementId,
      newAddress: newAddress,
    },
  };
};

export const changeAddressSuccess = () => {
  return {
    type: CHANGE_ADDRESS_SUCCESS,
  };
};

export const report = (_startDateTime, _endDateTime) => {
  return {
    type: ADMIN_REPORT,
    payload: {
      startDateTime: _startDateTime,
      endDateTime: _endDateTime,
    },
  };
};
export const reportSucess = (data) => {
  return {
    type: ADMIN_REPORT_SUCEESS,
    payload: data,
  };
};

export const getMissionById = (missionId) => {
  return {
    type: ADMIN_GET_MISSION_BY_ID,
    payload: {
      missionId: missionId,
    },
  };
};
export const getMissionByIdSuccess = (data) => {
  return {
    type: ADMIN_GET_MISSION_BY_ID_SUCCESS,
    payload: data,
  };
};

export const UpdateMission = (mission) => {
  return {
    type: ON_UPDATE_Missing,
    payload: mission,
  };
};

export const UpdateMissionSuccess = () => {
  return {
    type: ON_UPDATE_Missing_Success,
  };
};
